<template>
  <v-container>
    <!-- <TitleH1 text="Categorias" /> -->
    <v-row class="ma-0 categoryList">
      <v-col cols="12" sm="6" md="4" lg="3" v-for="categoria in listadecategorias" :key="categoria.idcategoriaprod" class="pa-1">
        <Categoria 
          :categoria="categoria" :idpdv="idpdv"
         />
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
  // import TitleH1 from './TitleH1.vue'
  import Categoria from './Categoria.vue'
  export default {
    name: 'CategoriaLista',
    props:['idpdv'],
    components:{
      // TitleH1,
      Categoria
    },
    data: () => ({
      listadecategorias:[]
    }),

    methods:{

      getCategorias(){
          this.$http(`pdv/getCategorias/${this.idpdv}/0/hospede`).then((resp) =>{
            this.listadecategorias = resp.data
          }).catch(error =>{
            console.log(error)
            this.$alertar("warning","Não foi possivel exibir as Categorias","=(")
          })
      },

    },

    mounted(){
      this.getCategorias()
    }



  }
</script>

<style scoped>
    .categoryList{
      /* background-color:green; */
      display:flex;
      flex-wrap: wrap;
      justify-content: center;
      width:100%;
      padding:0px!important;
    }
</style>
